import React from "react";
import { experienceData } from "../config/personalInfo";

export default function Experience() {
  return (
    <div className="flex flex-col items-center py-16 bg-gradient-to-b from-white to-gray-50">
      <div className="text-4xl font-bold font-heading md:text-5xl text-gray-800 mb-12">
        <span className="border-b-4 border-blue-500 pb-2">Experience</span>
      </div>

      <div className="max-w-screen-xl w-full px-4 md:px-8">
        <div className="grid gap-8 md:grid-cols-2">
          {experienceData.map((experience, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300"
            >
              <div className="p-6 space-y-4">
                <div className="flex flex-col space-y-2">
                  <div className="flex items-start justify-between gap-2">
                    <div className="min-w-0 flex-1">
                      <h3 className="text-xl sm:text-2xl font-bold text-gray-800 hover:text-blue-600 transition-colors duration-300 truncate">
                        {experience.title}
                      </h3>
                      <a
                        href={experience.companyUrl}
                        target="_blank"
                        rel="noreferrer"
                        className="text-base sm:text-lg text-blue-600 hover:text-blue-700 transition-colors duration-300 hover:underline truncate"
                      >
                        {experience.company}
                      </a>
                    </div>
                    <span className="flex-shrink-0 self-start px-3 py-1 bg-blue-50 text-blue-600 text-xs sm:text-sm font-medium rounded-full">
                      {experience.period}
                    </span>
                  </div>
                </div>

                <div className="flex flex-wrap gap-2">
                  {experience.technologies.map((tech) => (
                    <span
                      key={tech}
                      className="px-3 py-1 bg-gray-100 text-gray-700 text-sm rounded-full 
                        transition-all duration-200 hover:bg-blue-50 hover:text-blue-600 
                        transform hover:-translate-y-0.5"
                    >
                      {tech}
                    </span>
                  ))}
                </div>

                <div className="border-t border-gray-100 pt-4">
                  <ul className="space-y-3">
                    {experience.points.map((point, pointIndex) => (
                      <li key={pointIndex} className="flex items-start group">
                        <span
                          className="inline-block w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0
                          transition-all duration-300 group-hover:scale-125"
                        ></span>
                        <span className="text-gray-700 group-hover:text-gray-900 transition-colors duration-300">
                          {point}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
